<template>

	<div class="certificate-list">
		<b-row class="mb-3">
			<b-col cols="3">
				<label class="lebeltop">{{ $t('incomeFilter.department')}}</label>
				<multiselect
					v-model="filter.departmentId"
					:options="myDepartments"
					:multiple="true"
					track-by="id"
					:show-labels="false"
					:allow-empty="true"
					label="name"
					:placeholder="$t('promo-to-product.department')"
					class="multiselect-pricing"
				>
				</multiselect>

			</b-col>
			<b-col sm="2">
				<label class="lebeltop">
					{{ $t('incomeFilter.from')}}</label>
				<b-form-group
					label-size="sm"
					label-for="refName"
					class="required"
				>

					<date-picker v-model="filter.start"
								 lang="ru"
								 size="sm"
								 type="month"
								 placeholder="dd-mm-yyyy"
								 valueType="format"
								 format="DD-MM-YYYY"
					></date-picker>
				</b-form-group>
			</b-col>
			<b-col sm="3" style="margin-left: 30px;">
				<label class="lebeltop">
					{{ $t('incomeFilter.to')}}</label>
				<b-form-group
					label-size="sm"
					label-for="refName"
					class="required"
				>

					<date-picker v-model="filter.end"
								 lang="ru"
								 size="sm"
								 type="month"
								 placeholder="dd-mm-yyyy"
								 valueType="format"
								 format="DD-MM-YYYY"
					></date-picker>
				</b-form-group>
			</b-col>
			<b-col sm="2">
				<label class="lebeltop">
					<p></p></label>
				<b-form-group
					label-size="sm"
					label-for="refName"
					class="required"
				>
					<b-button @click="getDataByFilter" class="pull-right" variant="primary">{{
						$t('apply') }}
					</b-button>
				</b-form-group>

			</b-col>


		</b-row>
		<b-row>
			<b-col cols="8">

				<h5 v-if="filter.departmentId.length > 0">{{ $t('incomeFilter.department')}} : <span
					class="text-danger">{{ getDepsName()}}</span> <span
					class="text-success">&nbsp;&nbsp;(  {{ filter.start ? filter.start : getYear(true)}} {{ filter.end ? ' - ' + filter.end : '- ' + getYear()}}  )</span>
				</h5>
			</b-col>
		</b-row>

		<hr>
		<b-row v-if="emptyTable" class="mb-3">
			<b-col v-if="Object.keys(whDocList).length === 0" class="myContainer">
				<b-alert variant="danger" v-if="!loading" show>Нет доступных данных</b-alert>
				<div v-if="loading" class="spinner-wrapper">
					<b-spinner variant="primary"></b-spinner>
				</div>
			</b-col>

		</b-row>
		<div v-else>
			<b-row>
				<b-col cols="12">
					<b-alert show>
						{{ $t('alert_table_not_loaded')}}
					</b-alert>
				</b-col>
			</b-row>
			<b-row>
				<b-col cols="12">
					<div id="chart">
						<apexchart type=bar height=350 :options="chartOptions" :series="series"/>
					</div>
				</b-col>
			</b-row>
			<b-row>

				<b-col cols="12">
					<b-button @click="excelExport('tbssslData33','Export_Name')" variant="primary" class="pull-right"
							  :disabled="loading">Excel
					</b-button>
				</b-col>
			</b-row>
			<hr/>
			<b-row>
				<b-col cols="12">
					<div>
						<table class="table b-table table-striped" size="xs" id="tbssslData33" width="100%">
							<thead>

							<tr>
								<th class="text-center" scope="col">#</th>
								<th class="text-center" scope="col">{{ $t('incomeFilter.department')}}</th>
								<th class="text-center" scope="col">{{ $t('pos.qty')}}</th>
								<th class="text-center" scope="col">{{ $t('pos.sum') + " ( " +
									$t('warehouse.table.tableRetail') + " )"}}
								</th>
								<th class="text-center" scope="col">{{ $t('pos.sum') + " ( " +
									$t('warehouse.table.tableWholesale') + " )"}}
								</th>

							</tr>
							</thead>
							<tbody class="text-center">
							<tr v-for="item,index in whDocList">
								<td><b>{{ index + 1}}</b></td>
								<td>{{ item.depName}}</td>
								<td>{{ item.sumCount}}</td>

								<td class="cls1"> {{ item.sumPrice | currency({symbol:item.depCurrency.code,
									fractionCount: 2,
									symbolPosition: 'back'}) }}
								</td>
								<td class="cls1"> {{ item.sumPriceWholesale | currency({symbol:item.depCurrency.code,
									fractionCount: 2,
									symbolPosition: 'back'}) }}
								</td>


							</tr>

							</tbody>
						</table>
						<nav>
							<b-pagination :total-rows="filter.total" :per-page="filter.limit"
										  v-model="filter.page" :prev-text="$t('pagination.prev')"
										  :next-text="$t('pagination.next')" hide-goto-end-buttons/>
						</nav>
					</div>

				</b-col>
			</b-row>
		</div>

	</div>

</template>


<script>
	import Multiselect from 'vue-multiselect'
	import {mapActions, mapGetters, mapState} from "vuex";
	import Analytics from '../../services/analytics.service';
	import MonitoringService from '../../services/monitoring.service';
	import PosReportService from '../../services/pos.report.service';

	export default {
		name: 'MonthlyAnalytics',
		components: {Multiselect},
		data() {
			return {
				series: [],
				chartOptions: {},
				filter: {
					departmentId: [],
					start: null,
					end: null,
					total: null,
					page: 1,
					limit: 20,
				},
				departmentView: false,
				whDocList: [],
				whItemsByDate: [],
				emptyTable: true,
				emptyTable2: true,
				loading: false,
				extraCostModalItems: [],
				WhDocModalItems: [],
				currentDepName: ''

			}
		},
		methods: {
			...mapActions('departments', ['fetchMyDepartments']),

			getDepsName() {
				let str = '';
				this.filter.departmentId.forEach(el => {
					str += el.name + ", ";
				});
				return str;
			},

			getYear(startYear = false) {
				let today = new Date();
				var dd = String(today.getDate()).padStart(2, '0');
				var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
				var yyyy = today.getFullYear();

				if (startYear) {
					today = '01-01-' + yyyy;
				} else {
					today = dd + '-' + mm + '-' + yyyy;
				}


				return String(today);

			},
			filterDate(data) {
				let arr = [];
				arr = data.split('-');
				return String(arr[2] + "-" + arr[1] + "-" + arr[0])
			},
			async updateChart(dataFromServer) {
				this.series = [];
				let startMonth = 1;
				let endMonth = 12;
				if (this.filter.start !== null) {
					let ms = this.filter.start.split("-");
					startMonth = parseInt(ms[1]);
				}
				if (this.filter.end !== null) {
					let ms = this.filter.end.split("-");
					endMonth = parseInt(ms[1]);
				}
				let seriesList = [];
				let cats = [];
				const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
					"Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
				];
				cats = monthNames.slice(startMonth-1,endMonth);
				dataFromServer.forEach(dep => {
					let loopStart = startMonth;
					let loopEnd = endMonth;
					let obj = {};
					obj.name = dep.depName;
					let data = [];

					while (loopStart <= loopEnd) {
						if (dep.docList.length > 0) {
							let obj = dep.docList.filter(el => el.month == loopStart);
							obj.length > 0 ? data.push(obj[0].countSum) : data.push(0);
						} else {
							data.push(0)
						}

						loopStart++
					}
					obj.data = data;
					seriesList.push(obj);
					loopStart = startMonth;
					loopEnd = endMonth;
				});

				this.series = seriesList;
				this.chartOptions = {
					plotOptions: {
						bar: {
							horizontal: false,
							columnWidth: '55%',
							endingShape: 'rounded'
						},
					},
					dataLabels: {
						enabled: false
					},
					stroke: {
						show: true,
						width: 2,
						colors: ['transparent']
					},

					xaxis: {
						categories: cats,
					},
					yaxis: {
						title: {
							text: this.$t('sale.kol-vo')
						}
					},
					fill: {
						opacity: 1

					},
					tooltip: {
						y: {
							formatter: function (val) {
								return val
							}
						}
					}
				};

			},
			excelExport(table, name = '') {
				var uri = 'data:application/vnd.ms-excel;charset=UTF-8,base64,',
					template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>'
					, base64 = function (s) {
						return window.btoa(unescape(encodeURIComponent(s)))
					}
					, format = function (s, c) {
						return s.replace(/{(\w+)}/g, function (m, p) {
							return c[p];
						})
					};
				if (!table.nodeType) table = document.getElementById(table);
				var ctx = {worksheet: name || 'Worksheet', table: table.innerHTML};
				window.location.href = uri + base64(format(template, ctx));

			},
			async getDataByFilter() {

				if (this.filter.departmentId.length === 0) {
					this.$vs.notify({
						title: 'Пожалуйста выберите Отдел',
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});
					return false;
				}
				let searchFilter = {};
				searchFilter.depId = [];
				this.filter.departmentId.forEach(el => {
					searchFilter.depId.push(el.id)
				});
				let startMonth = this.filter.start !== null ? this.filter.start.split("-") : null;
				let endMonth = this.filter.end !== null ? this.filter.end.split("-") : null;
				searchFilter.fromDate = startMonth !== null ? parseInt(startMonth[1]) : null;
				searchFilter.toDate = endMonth !== null ? parseInt(endMonth[1]) : null;
				searchFilter.page = this.filter.page;
				searchFilter.limit = this.filter.limit;
				this.loading = true;
				await Analytics.getMonthlySaleList(searchFilter).then(response => {
					if (response.data.departments.length > 0) {
						this.whDocList = response.data.departments;
						this.filter.total = response.data.total;
						this.emptyTable = false;
					} else {
						this.whDocList = []
						this.emptyTable = true;
					}
				});
				await this.updateChart(this.whDocList);
				this.loading = false;


			},
			closeModalWindow(name) {
				this[name] = false;
			},
			async openModalExtraCount(id, docNumber) {
				this.docExtraCostModal = true;
				this.currentDocNumber = docNumber;
				await MonitoringService.getExtraCostByDocument(id).then(response => {
					this.extraCostModalItems = response.data;
				})
			},

		}
		,
		created() {
			this.fetchMyDepartments();
		}
		,
		computed: {
			...
				mapGetters('departments', [
					'myDepartments'
				]),
			...
				mapState(['userDepCurrencyName']),
		}
		,
		watch: {
			'filter.page':
				{
					handler() {
						this.getDataByFilter();
					}
				}
			,
		}
		,
	}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
	.alert {
		padding: 15px;
	}

	.cls1 {
		mso-number-format: "mso-number-format:\@;"
	}

	.spinner-wrapper {
		position: absolute;
		background: rgba(32, 28, 32, 0.49);
		left: 0;
		right: 0;
		text-align: center;
		top: 0;
		bottom: 0;
		padding-top: 35px;
		z-index: 5;
	}

	.loaderImg {
		position: absolute;
		left: 44%;
		top: 44%;
		z-index: 1;
		border: 6px solid #f3f3f3;
		border-radius: 50%;
		border-top: 6px solid #0092D3;
		border-bottom: 6px solid #0092D3;
		width: 60px;
		height: 60px;
		-webkit-animation: spin 1.6s linear infinite;
		animation: spin 1.6s linear infinite;
	}

	@-webkit-keyframes spin {
		0% {
			-webkit-transform: rotate(0deg);
		}
		100% {
			-webkit-transform: rotate(360deg);
		}
	}

	@keyframes spin {
		0% {
			transform: rotate(0deg);
		}
		100% {
			transform: rotate(360deg);
		}
	}
</style>
